/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Gads_TitleInputs */

const cs_integrations_gads_title = /** @type {(inputs: Integrations_Gads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Ads`)
};

const en_integrations_gads_title = /** @type {(inputs: Integrations_Gads_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Ads`)
};

/**
* | output |
* | --- |
* | "Google Ads" |
*
* @param {Integrations_Gads_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_gads_title = /** @type {((inputs?: Integrations_Gads_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Gads_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_gads_title(inputs)
	return cs_integrations_gads_title(inputs)
});